// import constant
import {
    SET_PROFILE_DATA,
    REMOVE_AUTH_ACCOUNT
} from '../constant';

const initialValue = {}

const profile = (state = initialValue, action) => {
    switch (action.type) {
        case SET_PROFILE_DATA:
            return {
                ...state,
                ...action.data
            };
        case REMOVE_AUTH_ACCOUNT:
            return initialValue;
        default:
            return state;
    }
}

export const setProfile = (dispatch, data) => {
    return dispatch({ type: SET_PROFILE_DATA, data })
}

export default profile;
